export type EditorialCommitteeMember = {
  docId?: string;
  name: string;
  post: string;
  place?: string;
  img?: string;
  order?: number;
};

export type YuvagaazEmagazine = {
  docId?: string;
  title: string;
  issue?: string;
  description?: string;
  releaseDate?: string;
  coverImage?: string;
  pdfUrl: string;
  createdAt?: string;
  updatedAt?: string;
};

export type YuvagaazMagazine = {
  docId?: string;
  title: string;
  year: string;
  pdfUrl: string;
  coverImage?: string;
  releaseDate?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type HistoricalEditorEntry = {
  id: number;
  bookLabel: string;
  yearValue: number;
  name: string;
  place?: string;
  img?: string;
};

export const defaultEditorialBoard: EditorialCommitteeMember[] = [
  {
    name: "Rev. Fr Steven Fernandes",
    post: "Director",
    img: "/images/fr.steevan.jpg",
    order: 1,
  },
  {
    name: "Lloyd Cornelio",
    place: "Mount Rosary Santhekatte",
    post: "Editor",
    img: "/images/editorialBoard/lloyd.png",
    order: 2,
  },
  {
    name: "Macklin Mendonca",
    place: "Belman",
    post: "Co-Editor",
    img: "/images/editorialBoard/macklin.jpeg",
    order: 3,
  },
  {
    name: "Alson Mathias",
    place: "Kanajar",
    post: "Member",
    img: "/images/editorialBoard/alson.png",
    order: 4,
  },
  {
    name: "Adroy Nazareth",
    place: "Milagres Kallianpur",
    post: "Member",
    img: "/images/editorialBoard/adroy.jpeg",
    order: 5,
  },
  {
    name: "Joyel Nazareth",
    place: "Byndoor",
    post: "Member",
    img: "/images/editorialBoard/joyel.png",
    order: 6,
  },
  {
    name: "Clinton Suares",
    place: "Udupi",
    post: "Member",
    img: "/images/editorialBoard/clinton.DNG",
    order: 7,
  },
  {
    name: "Melissa Roshni Dsouza",
    place: "Kanajar",
    post: "Member",
    img: "/images/editorialBoard/melissa.jpeg",
    order: 8,
  },
  {
    name: "Jeevan Mascarenhas",
    place: "Attur",
    post: "Member",
    img: "/images/editorialBoard/jeevan.jpeg",
    order: 9,
  },
  {
    name: "Diyona Fernandes",
    place: "Thottam",
    post: "Member",
    img: "/images/editorialBoard/diyona.jpeg",
    order: 10,
  },
];

export const CURRENT_BOOK_BASE_YEAR = 2026;
export const CURRENT_BOOK_BASE_NUMBER = 9;

export const historicalEditors: HistoricalEditorEntry[] = [
  {
    id: 1,
    bookLabel: "Book 9 - 2026",
    yearValue: 2026,
    name: "Lloyd Cornelio",
    place: "Mount Rosary Santhekatte",
    img: "/images/yuvagaazEditors/lloyd.png",
  },
  {
    id: 2,
    bookLabel: "Book 8 - 2025",
    yearValue: 2025,
    name: "Alson Mathias",
    place: "Kanajar",
    img: "/images/yuvagaazEditors/alson.png",
  },
  {
    id: 3,
    bookLabel: "Book 7 - 2024",
    yearValue: 2024,
    name: "Playson Dsouza",
    place: "Kuntalnagar",
    img: "/images/yuvagaazEditors/playson.jpg",
  },
  {
    id: 4,
    bookLabel: "Book 6 - 2023",
    yearValue: 2023,
    name: "Jackson Cabral",
    place: "Shirva",
  },
  {
    id: 5,
    bookLabel: "Book 5 - 2016",
    yearValue: 2016,
    name: "Elson Dsouza",
    place: "Hirgan",
  },
  {
    id: 6,
    bookLabel: "Book 3 & 4 - 2015-16",
    yearValue: 2015,
    name: "Derick Mascarenhas",
    place: "Kolalgiri",
  },
  {
    id: 7,
    bookLabel: "Book 1 & 2 - 2013-14",
    yearValue: 2013,
    name: "Roshan Sequeira",
    place: "Kuntalnagar",
  },
];

const defaultOrderLookup = new Map(
  defaultEditorialBoard.map((member, index) => [
    `${member.name}::${member.post}`,
    member.order || index + 1,
  ]),
);

function getPostPriority(post?: string) {
  switch (post?.trim().toLowerCase()) {
    case "director":
      return 1;
    case "editor":
      return 2;
    case "co-editor":
    case "co editor":
      return 3;
    default:
      return 4;
  }
}

export function sortEditorialCommitteeMembers(members: EditorialCommitteeMember[]) {
  return [...members].sort((memberA, memberB) => {
    const priorityDifference = getPostPriority(memberA.post) - getPostPriority(memberB.post);

    if (priorityDifference !== 0) {
      return priorityDifference;
    }

    const memberAOrder = memberA.order || defaultOrderLookup.get(`${memberA.name}::${memberA.post}`) || 999;
    const memberBOrder = memberB.order || defaultOrderLookup.get(`${memberB.name}::${memberB.post}`) || 999;

    if (memberAOrder !== memberBOrder) {
      return memberAOrder - memberBOrder;
    }

    return memberA.name.localeCompare(memberB.name);
  });
}

export function getCurrentBookNumber(currentYear: number) {
  return Math.max(
    CURRENT_BOOK_BASE_NUMBER + (currentYear - CURRENT_BOOK_BASE_YEAR),
    CURRENT_BOOK_BASE_NUMBER,
  );
}
